'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'floppy-disk';
var width = 448;
var height = 512;
var aliases = [128190,128426,"save"];
var unicode = 'f0c7';
var svgPathData = ['M48 80l0 352 352 0 0-268.1-80-80L320 184l0 24-24 0-192 0-24 0 0-24L80 80 48 80zM288 320a64 64 0 1 1 -128 0 64 64 0 1 1 128 0z', 'M48 480L0 480l0-48L0 80 0 32l48 0 288 0L448 144l0 288 0 48-48 0L48 480zm352-48l0-268.1-80-80L320 184l0 24-24 0-192 0-24 0 0-24L80 80 48 80l0 352 352 0zM128 80l0 80 144 0 0-80L128 80zm32 240a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFloppyDisk = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;